import React from "react";
import { Button, Icon } from "semantic-ui-react";
import Board from './../../drive/Activity/CommunityActivity';
import { dispatch } from '@rematch/core';
import ArrangementPane from './ArrangementPane'
import BreadCrumbsPage from './../../drive/cards/BreadCrumbs';
import EllipsisTooltip from './../../../../common/EllipsisTooltip';
import { withRouter } from 'react-router-dom';
import PlaybookActivityCard from '../../drive/cards/PlaybookActivityCard'
let treeArray = [];

class CommunityActivity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventBus: {}
    }
  }
  handleCardClick = async (e, card) => {
    await dispatch.createPack.getSelectedCommunityAsync(card._id);
    await dispatch.createPack.activityUniqueIdSet(card._id);
    await dispatch.lifeCycle.showResourecePane("CommunityFlow")
    await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    await dispatch.lifeCycle.splitAt("60%");
  }
  async componentWillMount() {
    dispatch.app.setRouteParams(this.props.match.params)
    //dispatch.createPack.clearDataForSelectedActivity();
    await dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(this.props.match.params.playbookId);
    dispatch.createPack.activityUniqueIdSet(null)
    dispatch.lifeCycle.showResourecePane(null);
    dispatch.lifeCycle.displaySecondMenu("Activities");
    dispatch.createPack.activityUniqueIdSet(null);
    dispatch.createPack.showDuplicateIcon(false);
    dispatch.lifeCycle.setArrangementPaneActiveButtonFlag("Assign")
  }

  getColor(id, communities) {
    if (!id)
      return '#fff'
    for (let community of communities) {
      if (community._id.toString() === id.toString()) {
        return community.tagColor;

      }
      for (let subcommunity of community.communities) {

        if (subcommunity._id.toString() === id.toString()) {
          return subcommunity.tagColor;
        }
      }
    }
  }

  WhichButton(event) {
    alert("You pressed button: " + event.button)
  }
  setCurrentLane(title, id) {
    this.setState({ laneId: id, laneName: title })
  }
  setEventBus = (handle) => {
    this.setState({ eventBus: handle })
  }
  render() {
    let communities = this.props.selectedPracticeLibrary.communities;
    let setColor;
    treeArray = this.props.selectedPracticeLibrary.communities;
    treeArray && treeArray.map((tree) => {
      if (typeof tree === 'object') {
        tree.lanes = [];
        tree.lanes = tree.communities.length > 0 ? tree.communities : [];

        tree.lanes.map((lane) => {
          if (lane.raci && lane.raci.a) {
            lane.communityTagColor = this.getColor(lane.raci.a, communities);
          }
          lane.title = lane.name;
          lane.cards = lane.activities ? lane.activities : [];
          lane.label = lane.cards.length > 0 ? lane.cards.length : '0';
          lane.cards.map((card) => {
            if (card.raci && card.raci.a) {
              card.communityTagColor = this.getColor(card.raci.a, communities);
            }
            card.title = card.name;
          })
        })
        if (tree.activities && tree.activities.length > 0) {

          if (tree.raci && tree.raci.a) {
            setColor = this.getColor(tree.raci.a, communities);
          }

          tree.activities.map((card) => {
            if (card.raci && card.raci.a) {
              card.communityTagColor = this.getColor(card.raci.a, communities);
            }
            card.title = card.name;
            // communityTagColor: setColor
          })
          let lane = {
            title: "Others",
            communityTagColor: setColor,
            cards: tree.activities,
            isDummy: true
          };
          tree.lanes.push(lane)
        }
      }

    })
    let height = this.props.componentDesignerDimension;
    return (
      <div className="containerBox">
        <ArrangementPane {...this.props} setPage="Assign" />
        <BreadCrumbsPage {...this.props} />
        <div className="activityTable overflowAuto">
          <div className="mainBox overflow-hide"
            style={{
              maxHeight: (height.windowHeight - height.height) - 130,
              minHeight: (height.windowHeight - height.height) - 130,
              'width': this.props.componentDesignerDimension.width - 80
            }}>
            {treeArray && treeArray.length && treeArray.map(function (tree, index) {
              let setWidth = tree.lanes && (tree.lanes.length === 1 || tree.lanes.length === 0) ?
                150 : tree.lanes.length * 160
              return (
                <div className="childBox" key={index}>
                  <div
                    onClick={e => this.handleCardClick(e, tree)}
                    className="phaseHeading"
                    onMouseEnter={() => dispatch.app.setHelpContext("Group Tile")}
                  >
                    <PlaybookActivityCard
                      type="phase"
                      page="assign"
                      selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                      activityData={Object.assign({}, tree)}
                      selectedActivity={this.props.selectedPracticeFlowCommunity}
                      enableLinkActivity={this.props.enableLinkActivity}
                      communities={this.props.selectedPracticeLibrary.communities}
                      _id={tree._id}
                      user={this.props.user}
                      currentOrganization={this.props.currentOrganization}
                    />

                  </div>
                  <Board
                    data={tree}
                    hideCardDeleteIcon={this.props.selectedPracticeLibrary.status !== 0}
                    draggable={this.props.selectedPracticeLibrary.status == 0}
                    editable
                    collapsibleLanes
                    tree={tree}
                    id={tree._id}
                    eventBusHandle={this.state.eventBus}
                    setCurrentLane={this.setCurrentLane}
                    addCardLink={<Button fluid className="buttonAdd" icon='plus' />}
                    {...this.props}
                  />
                </div>
              );
            }, this)}
          </div>
        </div>
      </div >
    );
  }
}
export default withRouter(CommunityActivity);
